// extracted by mini-css-extract-plugin
module.exports = {"top-menu":"top-menu_top-menu__Oiw5_","top-menu__three-dots-button":"top-menu_top-menu__three-dots-button__pXHIY"};